import type { Utility } from '../../../types/utility';

const baseVariantShared: Utility.CSSProperties = {
  width: '100%',
  padding: '24px',
};

const base = {
  default: {
    ...baseVariantShared,
  },
  large: {
    ...baseVariantShared,
    '[data-card-element="heading"]': {
      order: -1,
    },
    '[data-card-element="divider"]': {
      display: 'none',
    },
  },
};

const resourceCard: Utility.VariantKeyModes<ResourceCardVariantsType> = {
  products: {
    chart: base,
    chartblog: base,
    co: base,
    edu: base,
    scale: base,
    spark: base,
  },
};

export type ResourceCardVariantsType = 'default' | 'large';
export const resourceCardVariants = Object.keys(base) as ResourceCardVariantsType[];

export default resourceCard;
